import {Component, OnInit} from '@angular/core';
import {QuickLink} from '../suite/quick-links/quick-link.model';
import {QuickLinkService} from '../suite/quick-links/quick-link.service';

interface QuickLinkGroup {
  name: string;
  links: QuickLink[];
}

@Component({
  selector: 'app-quick-link-public',
  templateUrl: './quick-link-public.component.html',
  styleUrls: ['./quick-link-public.component.scss'],
})
export class QuickLinkPublicComponent implements OnInit {
  links: QuickLink[] = [];
  searchText = '';
  loading = true;
  loadFailed = false;

  constructor(private quickLinkService: QuickLinkService) {}

  ngOnInit(): void {
    this.quickLinkService.getPublicLinks().subscribe(
      (links) => {
        this.links = links || [];
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.loadFailed = true;
      },
    );
  }

  get groups(): QuickLinkGroup[] {
    const query = this.searchText.trim().toLowerCase();
    const filtered = this.links.filter((link) =>
      !query || [link.name, link.description, link.category]
        .filter((value) => !!value)
        .some((value) => value.toLowerCase().includes(query)),
    );

    const groups: QuickLinkGroup[] = [];
    filtered.forEach((link) => {
      let group = groups.find((item) => item.name === link.category);
      if (!group) {
        group = {name: link.category, links: []};
        groups.push(group);
      }
      group.links.push(link);
    });
    return groups;
  }
}
